interface IUrl {
  query(): object
  query(queryObj: object): string
}
/**
 * @description URL 模块
 */
class Url implements IUrl {
  private static rules: any = {
    query: '[?&]([^=&#]+)=([^&#]*)',
  }
  private url: string

  public constructor(_url) {
    this.url = _url
  }

  static query(queryObj?: object): any {
    if (!queryObj) {
      return Url.decomposeQueryString(location.href)
    }
    return Url.composeQueryString(queryObj)
  }
  private static decomposeQueryString(url: string): object {
    const reg: RegExp = new RegExp(Url.rules.query, 'g')
    const match: string[] = url.match(reg)
    const queryObj: object = {}
    let query: string[], key: string, value: string

    if (match && match.length > 0) {
      for (const item of match) {
        query = item.split('=')
        key = query[0].substr(1)
        value = decodeURIComponent(query[1])
        if (queryObj[key]) {
          queryObj[key] =
            typeof queryObj[key] === 'string'
              ? [queryObj[key], value]
              : [...queryObj[key], value]
        } else {
          queryObj[key] = value
        }
      }

      return queryObj
    }
    return null
  }

  private static composeQueryString(queryObj: object): string {
    let queryString = '?'
    for (const [key, value] of Object.entries(queryObj)) {
      queryString += `${key}=${value}&`
    }
    return queryString.substr(0, queryString.length - 1)
  }
  /**
   * @description 获取当前路径下的 querystring
   * 注意：JavaScript 由于是弱类型语言，仅支持基于参数个数的重载，故无法像 Java, C 那样重新定义重载函数；
   */
  public query(queryObj?: object): any {
    if (!queryObj) {
      return Url.decomposeQueryString(this.url)
    }

    return Url.composeQueryString(queryObj)
  }
}

export default Url
